import { formatPrice } from "@1-now/booking-core";

/**
 * An amount the way the bill prints it: "$" + formatPrice, which drops the cents of a whole amount
 * ("$350", "$377.90"). The phone steps use this and not `cash`, so the bar, the price sheet and the bill
 * say the same figure the same way (1NOW-11155).
 */
export const dollars = (v: unknown): string => `$${formatPrice(v as number | string | null | undefined)}`;
